import React from "react";
import { Dropdown, DropdownOption } from "./dropdown";
import "./nav-bar.css";
export interface NavBarItem {
    id: string;
    displayName: string;
    component: JSX.Element;
}

export interface NavBarProps {
    options: NavBarItem[];
    onItemSelected: (id: string) => void;
}

function NavBar(props: NavBarProps) {
    return (
        <>
            <nav id="navbar" role="navigation" aria-labelledby="pages-id">
                <Dropdown
                    options={props.options}
                    label="Go to:"
                    onOptionChanged={(id) => props.onItemSelected(id)}
                />
            </nav>
        </>
    );
}

export default NavBar;
